import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import http from "../../Utils/axiosConfig";
import { downloadCsv } from "../../Utils/csv";
import "./PaymentRegister.css";

const fmt = (v) => v != null ? Number(v).toFixed(2) : "-";
const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }) : "-";

const PaymentDetail = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { from_date, to_date } = location.state || {};

  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!from_date || !to_date) { setLoading(false); return; }
    const fetch = async () => {
      try {
        const res = await http.post("payment_register/detail", { from_date, to_date });
        setRows(res?.code === "DATA_FOUND" ? res.data : []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [from_date, to_date]);

  const handleExport = () => {
    if (!from_date || !to_date) return;
    downloadCsv(
      `payment-detail-${from_date}-to-${to_date}.csv`,
      [
        ["क्र.", (r) => r.member_number],
        ["नाव", (r) => r.member_name],
        ["पासून", (r) => fmtDate(r.from_date)],
        ["पर्यंत", (r) => fmtDate(r.to_date)],
        ["सकाळ (लि./रु.)", (r) => `${fmt(r.morning_milk)} / ${fmt(r.morning_rate)}`],
        ["संध्याकाळ (लि./रु.)", (r) => `${fmt(r.evening_milk)} / ${fmt(r.evening_rate)}`],
        ["एकूण दूध", (r) => fmt(r.total_milk)],
        ["एकूण दर", (r) => fmt(r.total_rate)],
        ["ॲडव्हान्स", (r) => fmt(r.advance)],
        ["पशुखाद्य", (r) => fmt(r.supply)],
        ["बँक", (r) => fmt(r.bank)],
        ["कपात", (r) => fmt(r.cutting)],
        ["देय रक्कम", (r) => fmt(r.grand_total)],
      ],
      rows,
    );
  };

  const totals = rows.reduce((acc, r) => {
    acc.morning_milk += Number(r.morning_milk || 0);
    acc.morning_rate += Number(r.morning_rate || 0);
    acc.evening_milk += Number(r.evening_milk || 0);
    acc.evening_rate += Number(r.evening_rate || 0);
    acc.total_milk   += Number(r.total_milk   || 0);
    acc.total_rate   += Number(r.total_rate   || 0);
    acc.advance      += Number(r.advance      || 0);
    acc.supply       += Number(r.supply       || 0);
    acc.bank         += Number(r.bank         || 0);
    acc.cutting      += Number(r.cutting      || 0);
    acc.grand_total  += Number(r.grand_total  || 0);
    return acc;
  }, { morning_milk:0, morning_rate:0, evening_milk:0, evening_rate:0, total_milk:0, total_rate:0, advance:0, supply:0, bank:0, cutting:0, grand_total:0 });

  return (
    <div className="pr-container">
      <div className="pr-detail-header">
        <button className="pr-back-btn" onClick={() => navigate("/payment")}>
          ← मागे
        </button>
        <div className="pr-detail-period">
          {from_date && to_date
            ? `${fmtDate(from_date)}  —  ${fmtDate(to_date)}`
            : "कालावधी उपलब्ध नाही"}
        </div>
        {rows.length > 0 && (
          <button className="pr-back-btn" onClick={handleExport}>⬇ Download</button>
        )}
      </div>

      {loading ? (
        <div className="pr-no-data"><p>लोड होत आहे...</p></div>
      ) : rows.length === 0 ? (
        <div className="pr-no-data"><p>या कालावधीसाठी नोंदी उपलब्ध नाहीत.</p></div>
      ) : (
        <div className="pr-table-wrap">
          <table className="pr-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>नाव</th>
                <th>पासून</th>
                <th>पर्यंत</th>
                <th>सकाळ (लि./रु.)</th>
                <th>संध्याकाळ (लि./रु.)</th>
                <th>एकूण दूध</th>
                <th>एकूण दर</th>
                <th>ॲडव्हान्स</th>
                <th>पशुखाद्य</th>
                <th>बँक</th>
                <th>कपात</th>
                <th>देय रक्कम</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td>{r.member_number}</td>
                  <td className="pr-name">{r.member_name}</td>
                  <td>{fmtDate(r.from_date)}</td>
                  <td>{fmtDate(r.to_date)}</td>
                  <td>{fmt(r.morning_milk)} / {fmt(r.morning_rate)}</td>
                  <td>{fmt(r.evening_milk)} / {fmt(r.evening_rate)}</td>
                  <td>{fmt(r.total_milk)}</td>
                  <td>{fmt(r.total_rate)}</td>
                  <td>{fmt(r.advance)}</td>
                  <td>{fmt(r.supply)}</td>
                  <td>{fmt(r.bank)}</td>
                  <td>{fmt(r.cutting)}</td>
                  <td className="pr-gross">{fmt(r.grand_total)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4}>एकूण</td>
                <td>{fmt(totals.morning_milk)} / {fmt(totals.morning_rate)}</td>
                <td>{fmt(totals.evening_milk)} / {fmt(totals.evening_rate)}</td>
                <td>{fmt(totals.total_milk)}</td>
                <td>{fmt(totals.total_rate)}</td>
                <td>{fmt(totals.advance)}</td>
                <td>{fmt(totals.supply)}</td>
                <td>{fmt(totals.bank)}</td>
                <td>{fmt(totals.cutting)}</td>
                <td>{fmt(totals.grand_total)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
};

export default PaymentDetail;
